import { render, staticRenderFns } from "./SubArticleCreateDialog.vue?vue&type=template&id=cd27c37e&"
import script from "./SubArticleCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./SubArticleCreateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./SubArticleCreateDialog.vue?vue&type=style&index=0&id=cd27c37e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports